import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { SendWidgetMessageRequest, SendWidgetMessageResponse } from 'server';
import { appFetch } from './appFetch';
import { widgetKeys } from './keys';

export const useSendMessage = (chatId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (request: SendWidgetMessageRequest): Promise<SendWidgetMessageResponse> => {
      const response = await appFetch<SendWidgetMessageResponse>(
        `/app/public/widget/chats/${chatId}/message`,
        {
          method: 'POST',
          body: request
        }
      );
      return response;
    },
    onSuccess: () => {
      // Invalidate chat data to refetch messages
      queryClient.invalidateQueries({
        queryKey: widgetKeys.chat(chatId)
      });
    }
  });
};
